import styled from 'styled-components';

export default styled.div`
	flex: 0 0 30%;
	position: relative;
	padding: 2rem;
	.imgWrap {
		position: relative;
		border-radius: 50%;
		background-color: ${(p) => p.theme.color.primary};
		padding-bottom: 100%;
		width: 100%;
		&:hover .face {
			opacity: 0;
		}
		&:hover .overlay {
			transform: scale(1.1);
		}
		.face {
			opacity: 1;
			width: 100%;
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			z-index: 1;
		}
		.overlay {
			width: 100%;
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			transform: scale(1.05);
			transition: transform 300ms ease-in-out;
			z-index: 2;
		}
		.anim {
			position: absolute;
			width: 100%;
			height: auto;
			z-index: 0;
			mix-blend-mode: darken;
		}
	}
	.body {
		position: relative;
		/*margin-top: -3rem;*/
		h3 {
			font-family: ${(p) => p.theme.font.display};
			font-size: 2rem;
			max-width: 50%;
			margin-bottom: 0.5rem;
		}
		h4 {
			font-weight: 700;
			margin-bottom: 0.5rem;
		}
	}
	@media ${(p) => p.theme.device.mobile} {
		flex: 0 0 100%;
	}
`;
